import { MessageTemplateBaseDto, MessageTemplateDto } from "@beyou/app/core/dto/message-templates/message-template.dto";
import { MessageTemplateUpdateDto } from "@beyou/app/core/dto/message-templates/message-template-update.dto";
import { MessageTemplate, MessageTemplateBase } from "../../models/message-template.model";

export class MessageTemplateMapper {
  public static toModel(dto: MessageTemplateDto): MessageTemplate {
    return {
      id: dto.id,
      code: dto.code,
      text: dto.text,
      supportedTemplateVariables: dto.supported_template_variables,
    }
  }

  public static toCreateDto(model: MessageTemplateBase): MessageTemplateBaseDto {
    return {
      code: model.code,
      text: model.text,
      supported_template_variables: model.supportedTemplateVariables,
    }
  }

  public static toUpdateDto(model: MessageTemplate): MessageTemplateUpdateDto {
    return {
      supported_template_variables: model.supportedTemplateVariables,
    }
  }
}
